import { EpisodeBase } from "./episodes-types";

export enum SubmissionState {
  "unsubmitted" = "unsubmitted",
  "finalCheck" = "finalCheck", // applies only to whole episodes, not individual assets
  "submitted" = "submitted",
}

export type AssetsReadyForSubmissionResponseData = AssetReadyForSubmission[];

export type AssetReadyForSubmission = EpisodeBase & {
  imagesForSubmissionSummary: {
    rejected: number;
    accepted: number;
  };
  masksForSubmissionSummary: {
    rejected: number;
    accepted: number;
  };
};

export type SubmitAssetsRequestData = {
  episodeIds: string[];
};
